"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (basePath, id) {
  return basePath + "/" + encodeURIComponent(id);
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/admin-on-rest/lib/util/linkToRecord.js
// module id = 116
// module chunks = 0